// Decide the id to send to the question API when saving a question.
//
// Cloning only applies when saving INTO a real survey (`survey.id` present). There, a shared
// question-bank / template question (isAdmin) is cloned into a survey-owned copy — id 0 tells
// the API to create a new question — so editing it never mutates the shared original, and every
// template question clones independently; a question the survey already owns (isAdmin false)
// keeps its id and is updated in place.
//
// Outside a survey — the SuperAdmin question-bank editor reuses this component with no
// survey.id — admin questions ARE the bank questions and must be edited in place, so we keep
// their id (cloning there would create duplicate bank questions).
//
// This replaces keying the decision off the survey-level templateId, which forced TemplateId
// to be overwritten (breaking benchmarking) and only cloned the first edited question.
export const questionIdForSave = (sourceQuestion, survey) => {
  if (survey?.id && sourceQuestion?.isAdmin) return 0
  return sourceQuestion?.id ?? 0
}
